import http from '../../utils/http'; //封装的拦截器及错误处理的axios
import Qs from 'qs'

const registerApi = {
  usernameUnique2(params) {
    return http({
      method: 'get',
      url: 'username_unique2.jspx',
      params: params
    })
  },
  zzjgdmUnique(params) {
    return http({
      method: 'get',
      url: 'zzjgdm_unique2.jspx',
      params: params
    })
  },
  companyNameUnique2(params) {
    return http({
      method: 'get',
      url: 'companyName_unique2.jspx',
      params: params
    })
  },
  captchaValidate(params) {
    return http({
      method: 'get',
      url: 'captcha_validate.jspx',
      params: params
    })
  },
  doRegister(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: 'submitRegister.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  doRegisterVaccine(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: 'vaccine/submitRegister.jspx',
      data: Qs.stringify(reqdata)
    })
  },
  forgotPassword(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: 'member/submit_forgot.jspx',
      data:Qs.stringify(reqdata)
    })
  },
  resetPassword(reqdata){
    return http({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post',
      url: 'member/reset_password2.jspx',
      data:Qs.stringify(reqdata)
    })
  },
  getRegisterInvalid(params){
    return http({
      method: 'get',
      url: 'register/invalid.jspx',
      params: params
    })
  }
};
export default  registerApi;



// WEBPACK FOOTER //
// ./src/api/user/register.js